import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import usersSVG from '@plone/volto/icons/group.svg';
import linkSVG from '@plone/volto/icons/link.svg';
import listBulletSVG from '@plone/volto/icons/list-bullet.svg';
import navSVG from '@plone/volto/icons/nav.svg';

import ConteudosRelacionadosEdit from 'volto-ministerio-publico-federal/components/Blocks/ConteudosRelacionados/Edit';
import ConteudosRelacionadosView from 'volto-ministerio-publico-federal/components/Blocks/ConteudosRelacionados/View';
import { ConteudosRelacionadosBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/ConteudosRelacionados/adapter';
import ContextNavigationEdit from 'volto-ministerio-publico-federal/components/Blocks/ContextNavigation/Edit';
import ContextNavigationView from 'volto-ministerio-publico-federal/components/Blocks/ContextNavigation/View';
import ServicosDestaqueEdit from 'volto-ministerio-publico-federal/components/Blocks/ServicosDestaque/Edit';
import ServicosDestaqueView from 'volto-ministerio-publico-federal/components/Blocks/ServicosDestaque/View';
import MpfUnidadeResponsavelBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/UnidadeResponsavel/Edit';
import MpfUnidadeResponsavelBlockView from 'volto-ministerio-publico-federal/components/Blocks/UnidadeResponsavel/View';

import { GROUP_SLOTS } from './groups';

/**
 * Blocos da lateral. Todos `restricted` e `isSlotFill`: não entram pelo menu
 * de blocos do conteúdo, só pelo painel de slots.
 */
export const slotBlocks = {
  contextNavigation: {
    id: 'contextNavigation',
    title: 'Navigation',
    icon: navSVG,
    group: GROUP_SLOTS,
    view: ContextNavigationView,
    edit: ContextNavigationEdit,
    schema: BlockSettingsSchema,
    restricted: true,
    isSlotFill: true,
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 1,
  },
  mpfServicosDestaque: {
    id: 'mpfServicosDestaque',
    title: 'Serviços em Destaque',
    icon: listBulletSVG,
    group: GROUP_SLOTS,
    view: ServicosDestaqueView,
    edit: ServicosDestaqueEdit,
    restricted: true,
    isSlotFill: true,
    mostUsed: false,
    sidebarTab: 1,
  },
  // RF03/RF04: independente dos demais componentes da lateral. Sem `edit`
  // com painel de ajustes — o bloco não tem dado próprio, só posiciona o
  // card (ver `components/Blocks/UnidadeResponsavel/View`). Quando NÃO
  // está na lateral, o card vai para o rodapé do conteúdo, no
  // `ContentContainer` — desligar o bloco muda o lugar, não a existência.
  mpfUnidadeResponsavel: {
    id: 'mpfUnidadeResponsavel',
    title: 'Área responsável',
    icon: usersSVG,
    group: GROUP_SLOTS,
    view: MpfUnidadeResponsavelBlockView,
    edit: MpfUnidadeResponsavelBlockEdit,
    restricted: true,
    isSlotFill: true,
    mostUsed: false,
    sidebarTab: 0,
  },
  mpfConteudosRelacionados: {
    id: 'mpfConteudosRelacionados',
    title: 'Conteúdos Relacionados',
    icon: linkSVG,
    group: GROUP_SLOTS,
    view: ConteudosRelacionadosView,
    edit: ConteudosRelacionadosEdit,
    dataAdapter: ConteudosRelacionadosBlockDataAdapter,
    restricted: true,
    isSlotFill: true,
    mostUsed: false,
    sidebarTab: 1,
  },
};

export default slotBlocks;
